export type State = FilterState | SegmentationState;
export type FilterState = 'benchmark' | 'main' | 'closed';
export type SegmentationState = 'segmentation1' | 'segmentation2' | 'closed';

export enum IntercomArticleKeys {
  FILTER_TRAY = 'FILTER_TRAY',
  DATA_VIEW = 'DATA_VIEW',
  BENCHMARK = 'BENCHMARK',
  FORECAST = 'FORECAST',
  SEGMENT = 'SEGMENT',
  EXPORT = 'EXPORT',
}

export enum ExportOptions {
  PDF_IMAGE = 'PDF_IMAGE',
  PNG_IMAGE = 'PNG_IMAGE',
}

export enum ImageExportTypes {
  PDF = 'pdf',
  PNG = 'png',
}
